// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import type { Connector } from 'react-redux';

// Components
import Scroller from '../components/Scroller';
// Actions
import { findProductsBySubdepartment } from '../actions';
// Selectors
import {
  subdepartmentSelector,
  loadingBySubdepartmentSelector,
} from "../selectors";
// Types
import type { Product } from '../../types';

type OwnProps = {
  productIds: number[],
  title: string,
  acessedSubdepartment: String,
  subdepartmentId: number,
  subdepartmentSlug: String,
  subdepartmentLink: String,
};

type Props = OwnProps & {
  isLoading: boolean,
  products: Product[],
  findProductsBySubdepartment: (number[]) => void,
};

const SubdepartmentScroller = (props: Props) => {
  const {
    subdepartmentId,
    title,
    acessedSubdepartment,
    subdepartmentSlug,
    subdepartmentLink,
    products,
    isLoading,
    findProductsBySubdepartment,
  } = props;

  useEffect(() => {
    if (products && products.length === 0) {
      findProductsBySubdepartment(subdepartmentId);
    }
  }, [products.length]);
  return (
    <Scroller
      id={subdepartmentSlug}
      title={title}
      slug={subdepartmentLink}
      products={products}
      isLoading={isLoading}
      scrollable={acessedSubdepartment === subdepartmentSlug}
    />
  );
};

const mapStateToProps = (state: mixed, ownProps: OwnProps) => {
  return {
    products: subdepartmentSelector(state, ownProps.subdepartmentId),
    isLoading: loadingBySubdepartmentSelector(state, ownProps.subdepartmentId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => {
  return {
    findProductsBySubdepartment: (subdepartmentId: number) => {
      dispatch(findProductsBySubdepartment(subdepartmentId));
    },
  };
};

const connector: Connector<OwnProps, Props> = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default connector(SubdepartmentScroller);
